export const getUserRole = isSelect => (isSelect ? 'select' : 'customer');

export const getSubscriptiontate = subscriptions =>
  (
    subscriptions && subscriptions.live && subscriptions.live.length
      ? subscriptions.live[0].state : 'expired'
  );



// WEBPACK FOOTER //
// ./src/utils/user.js